import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import FormError from "../../components/forms/FormError";
import DropDownInputField from "../../components/forms/DropDownInputField";
import DateInputField from "../../components/forms/DateInputField";


function CreateBreakageReportForm(props) {

  const {errors, handleSubmit, submit, submitting} = props;
  const submitLabel = submitting ? "Standby..." : "Submit"; 

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <Field 
            label="Jurisdiction"
            name="shopId"
            component={DropDownInputField}
            data={props.territories}
            valueKey="id"
            titleKey="name"
            showBlank={true}
            serverError={props.errors.shopId}
          />
          <Field 
            label="From date"
            name="minDate"
            component={DateInputField}
            options={{yearSelectable: true}}
            showDatePicker={props.showDatePicker}
            serverError={props.errors.minDate}
          />
          <Field 
            label="To date"
            name="maxDate"
            component={DateInputField}
            options={{yearSelectable: true}}
            showDatePicker={props.showDatePicker}
            serverError={props.errors.maxDate}
          />
        </FormFieldsTable>
      </div>
      <FormError error={errors._error} />
      <div className="buttons">
        <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
        <ActionButton label="Cancel" active={!submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
}

const ReduxForm = reduxForm({
  form: "CreateBreakageReportForm"
})(CreateBreakageReportForm);


export default ReduxForm;